<template>
  <router-link
    type="button"
    class="btn btn-lg btn-dark fw-bold shadow-sm"
    :to="{ name: to }"
  >
    <div class="d-inline-flex align-items-center gap-2">
      <span>{{ label }}</span>
      <i class="bi fs-3" :class="[`bi-${icon}`]"></i>
    </div>
  </router-link>
</template>

<script>
export default {
  name: "RouterButton",
  props: {
    to: {
      type: [String, Object],
      required: true
    },
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    }
  }
};
</script>
